
import enMessages from '../locales/es_ES';

const EnLang = {
    messages: {
        ...enMessages
    },
    locale: 'es-ES',

};
export default EnLang;